import { VulnerabilitiesAppWebComponent } from './component/VulnerabilitiesAppWebComponent';
import { WEB_COMPONENT_VULNERABILITIES_APP } from '../../webcomponents.constants';

export { VulnerabilitiesAppWebComponent };

window.customElements.define(WEB_COMPONENT_VULNERABILITIES_APP, VulnerabilitiesAppWebComponent);
